module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn btn-info ",
    on: {
      "click": function($event) {
        _vm.myReservations()
      }
    }
  }, [_vm._v("Go to Bookings")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info ",
    on: {
      "click": function($event) {
        _vm.findSitters()
      }
    }
  }, [_vm._v("Find Sitters")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("Go Home")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title text-center"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Reservation Completed ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('p', [_vm._v("The sitter will be notified of your request and will review the details and answer you soon.")]), _vm._v(" "), _c('p', [_vm._v("You can send another reservation to different sitter as well to ensure that at least one of them is available, go to Find Sitters if you want to contact another sitter.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4eea7a76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Reservation/ReservationSuccess.vue
// module id = 631
// module chunks = 2